import script from "./DaysSinceTheInfractionPill.vue?vue&type=script&setup=true&lang=js"
export * from "./DaysSinceTheInfractionPill.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__